import { IViolation } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { DataFlowColumn } from '../dataset/dataflowcolumn';
import { ExpressionBasedColumn } from './expression-based.column';
import { ColumnExpressionProcessor } from './column-expression-processor';
import { format } from 'app/shared/utils/string.util';
import { BaseGroupByTransformation } from './base-group-by-transformation';

@Metamodel.model({
    name: 'basepivottransformation', // As this is abstract this will never be used
    abstract: true
})
export abstract class BasePivotTransformation extends BaseGroupByTransformation {
    public transformationLabel: string = '';

    @Metamodel.attribute({
        type: DataFlowColumn.MODEL,
        constraint: {
            validator: BasePivotTransformation.validatePivotKeyValues
        }
    })
    public pivotKeyValues: string[] = [];

    public lateralColumnArrangement: boolean = true;
    public nullValue: boolean = false;
    public pivotValuesRequired: boolean;

    protected _pivotColumns: ExpressionBasedColumn[];

    public abstract get pivotColumns(): ExpressionBasedColumn[];

    public constructor() {
        super();
        this.inspectSummaryOutputFields.splice(1, 0, {
            name: () => stringResources.TransformationInspect_Dropped,
            value: () => this.droppedColumns.length
        });
        this.inspectDetailsOutputFields.unshift({
            name: () => this.columnInfoTitle,
            value: this.getColumnModificationType.bind(this)
        });
    }

    private static validatePivotKeyValues(transformation: BasePivotTransformation, value: string[]): IViolation[] | undefined {
        if (!transformation.pivotKeyValues.length && transformation.pivotValuesRequired) {
            return [
                {
                    context: transformation,
                    message: () => format(stringResources.PivotTransformationPivotKeyValueRequired, transformation.transformationLabel)
                }
            ];
        }
        return undefined;
    }

    public getColumnModificationType(column: DataFlowColumn): string {
        if (this._pivotColumns && this._pivotColumns.find((v) => {
            const colName = v instanceof DataFlowColumn ? v.name : v.column.name;
            return colName === column.name;
        }) != null) {
            return this.transformationLabel;
        }
        if (this.groupByColumns.find((c) => c.column === column) != null) {
            return stringResources.GroupbyLabel;
        }
        return '-';
    }

    public get columns(): DataFlowColumn[] {
        const output = ColumnExpressionProcessor.processNewColumns([].concat(this.groupByColumns, this.pivotColumns), this.distinctInputColumnRefs, this)
            .map((processedColumnResult) => processedColumnResult.column);

        this.droppedColumns = [];
        this.unchangedColumns = [];
        this.newColumns = [];
        this.distinctInputColumnRefs.forEach((col) => {
            if (output.find((v) => v.name === col.name)) {
                this.unchangedColumns.push(col.column);
            } else {
                this.droppedColumns.push(col.column);
            }
        });
        this.newColumns = output.filter((v) => this.unchangedColumns.find((col) => col.name === v.name) == null);
        return output;
    }
}
